import React from 'react';

/**
 * Title component
 * @component
 * @returns
 */
export const Title = ({ children, ...props }) => {
  return <h1 { ...props }>{ children }</h1>;
};